import {Component, DestroyRef, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CurrentTenantService} from "../../../../../../../../services/front/current-tenant.service";
import {AddRoutersToNetworkDialogData} from "../network-routers.component";
import {TenantService} from "../../../../../../../../services/tenant.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {SnackbarService} from "../../../../../../../../services/front/snackbar.service";
import {NetworkService} from "../../../../../../../../services/back/network.service";
import {FormControl} from "@angular/forms";
import {distinctUntilChanged, finalize, Observable, of, Subscription, switchMap, tap} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {debounceTime} from "rxjs/operators";
import {ChipsModule} from "../../../../../../../global/chips/chips/chips.module";
import {DesignSystemModule} from "../../../../../../../design-system/design-system.module";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {NgForOf, NgIf} from "@angular/common";
import {RouterIconComponent} from "../../../../../../../design-system/router-icon/router-icon.component";
import {ListLoaderComponent} from "../../../../../../../global/title-content-loader/list-loader.component";

@Component({
  selector: 'app-add-routers-to-network',
  standalone: true,
	imports: [
		ChipsModule,
		DesignSystemModule,
		MatCheckboxModule,
		NgForOf,
		NgIf,
		TranslateModule,
		RouterIconComponent,
		ListLoaderComponent
	],
  templateUrl: './add-routers-to-network.component.html',
  styleUrl: './add-routers-to-network.component.scss'
})
export class AddRoutersToNetworkComponent {
	constructor(public dialog: MatDialogRef<AddRoutersToNetworkComponent>,
				@Inject(MAT_DIALOG_DATA) public data: { networkId: string, routers: AddRoutersToNetworkDialogData[] },
				protected currentTenantService: CurrentTenantService,
				protected tenantService: TenantService,
				protected translate: TranslateService,
				protected destroyRef: DestroyRef,
				protected networkService: NetworkService,
				protected snackbarService: SnackbarService) {
	}

	searchInput: FormControl;

	searchLoading = false;

	_saving = false;

	tenantId: string;

	subscriptions: Subscription = new Subscription();

	filteredRouters: AddRoutersToNetworkDialogData[] = [];

	updatedRouters: AddRoutersToNetworkDialogData[] = [];

	ngOnInit() {
		this.subscriptions.add(this.currentTenantService.getCurrentTenantIdChanges()
			.pipe(
				tap(tenantId => this.tenantId = tenantId),
				takeUntilDestroyed(this.destroyRef)
			).subscribe());

		this.filteredRouters = this.data.routers;

		this.searchInput = new FormControl();
		if (this.data.routers.length > 0) {
			this.searchInput.valueChanges
				.pipe(
					tap(() => this.searchLoading = true),
					debounceTime(300),
					distinctUntilChanged(),
					tap(value => {
						return this.filteredRouters = this.data.routers.filter(item => item.router.name.toLowerCase().includes(value.toLowerCase()));
					}),
					tap(() => this.searchLoading = false)
				)
				.subscribe()
		}
	}

	onConfirm(): void {
		if (this.updatedRouters.length <= 0)
			return this.dialog.close({success: true});

		this.switchSaving()
			.pipe(
				switchMap(() => {
					const body: { routerId: string, selected: boolean }[] = this.updatedRouters.map((router) => {
						return {
							routerId: router.router.id,
							selected: router.selected
						}
					});
					return this.networkService.updateNetworkRouterList(this.tenantId, this.data.networkId, body)
				}),
				finalize(() => this.switchSaving())
			).subscribe({
			error: () => {
				this.dialog.close({success: false});
			},
			next: () => {
				this.dialog.close({success: true});
			}
		})
	}

	onDismiss() {
		this.dialog.close({servers: []});
	}

	onRouterSelectChange(router: AddRoutersToNetworkDialogData, event: any) {
		const foundRouter = this.data.routers.find(s => s.router.id === router.router.id && s.selected === event.checked);
		if (foundRouter) {
			this.updatedRouters = this.updatedRouters.filter(s => s.router.id !== router.router.id);
		} else {
			router.selected = event.checked;
			this.updatedRouters.push(router);
		}
	}

	switchSaving(): Observable<{}> {
		this._saving = !this._saving;
		return of({});
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}
}
